import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Primary
var primarySwatch = {
	background: '#4A84FF'
};
var primaryVariable = '$color-primary';
var primaryHex = '#4A84FF';

// Secondary
var secondarySwatch = {
	background: '#F5F6FA'
};
var secondaryVariable = '$color-secondary';
var secondaryHex = '#F5F6FA';

// Accent 1
var accent1Swatch = {
	background: '#8B93A7'
};
var accent1Variable = '$color-accent1';
var accent1Hex = '#8B93A7';

//Accent 2
var accent2Swatch = {
	background: '#E5E6EB'
};
var accent2Variable = '$color-accent2';
var accent2Hex = '#E5E6EB';

//Accent 3
var accent3Swatch = {
	background: '#DBE7FF'
};
var accent3Variable = '$color-accent3';
var accent3Hex = '#DBE7FF';

// Black
var blackSwatch = {
	background: '#000000'
};
var blackVariable = '$color-black';
var blackHex = '#000000';

//White
var whiteSwatch = {
	background: '#ffffff'
};
var whiteVariable = '$color-white';
var whiteHex = '#ffffff';

//Gray 1
var gray1Swatch = {
	background: '#F0F0F0'
};
var gray1Variable = '$color-gray1';
var gray1Hex = '#F0F0F0';

//Gray 2
var gray2Swatch = {
	background: '#B6B3C0'
};
var gray2Variable = '$color-gray2';
var gray2Hex = '#B6B3C0';

var successSwatch = {
	background: '#8AEE9B'
};
var successVariable = '$color-success';
var successHex = '#8AEE9B';

var errorSwatch = {
	background: '#FF9090'
};
var errorVariable = '$color-error';
var errorHex = '#FF9090';

var warningSwatch = {
	background: '#FEEFB3'
};
var warningVariable = '$color-warning';
var warningHex = '#FEEFB3';

//Returning the component
class GlobalColors extends Component {
	render() {
		return (
			<ul className="global-colors">
				<li>
					<span className="global-swatch" style={primarySwatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{primaryVariable}</p>
						<p className="textParagraph margin-bottom-0">{primaryHex}</p>
					</span>
				</li>
				<li>
					<span className="global-swatch" style={secondarySwatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{secondaryVariable}</p>
						<p className="textParagraph margin-bottom-0">{secondaryHex}</p>
					</span>
				</li>

				<li>
					<span className="global-swatch" style={accent1Swatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{accent1Variable}</p>
						<p className="textParagraph margin-bottom-0">{accent1Hex}</p>
					</span>
				</li>

				<li>
					<span className="global-swatch" style={accent2Swatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{accent2Variable}</p>
						<p className="textParagraph margin-bottom-0">{accent2Hex}</p>
					</span>
				</li>

				<li>
					<span className="global-swatch" style={accent3Swatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{accent3Variable}</p>
						<p className="textParagraph margin-bottom-0">{accent3Hex}</p>
					</span>
				</li>

				<li>
					<span className="global-swatch" style={blackSwatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{blackVariable}</p>
						<p className="textParagraph margin-bottom-0">{blackHex}</p>
					</span>
				</li>

				<li>
					<span className="global-swatch" style={whiteSwatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{whiteVariable}</p>
						<p className="textParagraph margin-bottom-0">{whiteHex}</p>
					</span>
				</li>
				<li>
					<span className="global-swatch" style={gray1Swatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{gray1Variable}</p>
						<p className="textParagraph margin-bottom-0">{gray1Hex}</p>
					</span>
				</li>

				<li>
					<span className="global-swatch" style={gray2Swatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{gray2Variable}</p>
						<p className="textParagraph margin-bottom-0">{gray2Hex}</p>
					</span>
				</li>

				<li>
					<span className="global-swatch" style={successSwatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{successVariable}</p>
						<p className="textParagraph margin-bottom-0">{successHex}</p>
					</span>
				</li>

				<li>
					<span className="global-swatch" style={errorSwatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{errorVariable}</p>
						<p className="textParagraph margin-bottom-0">{errorHex}</p>
					</span>
				</li>

				<li>
					<span className="global-swatch" style={warningSwatch}></span>
					<span className="global-label">
						<p className="textParagraph margin-bottom-0">{warningVariable}</p>
						<p className="textParagraph margin-bottom-0">{warningHex}</p>
					</span>
				</li>

			</ul>
		)
	}
}

export default GlobalColors;


// WEBPACK FOOTER //
// ./src/redux/components/atoms/GlobalColors.jsx